import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class MailingLabelService {
  constructor(private http: HttpUtilService) {}

  GetModelDrpList(): Observable<any> {
    return this.http.get("SalesReportService.asmx/GetModelDrpList");
  }

  MailingLabelReport(
    id: string,
    FromDate: string,
    ToDate: string,
  ): Observable<any> {
    return this.http.post(
      "SalesReportService.asmx/MailingLabelReport",
      {
        id,
        model: {
          FromDate,
          ToDate,
        },
      },
    );
  }
}
